export default "__VITE_ASSET__Bk7Vgm1l__"